"use client";
import { overlayBackdropClassNames as e, overlaySurfaceClassNames as t, overlayTitleClassNames as n } from "../overlays/overlay-class-names.js";
import { OverlayFrame as r } from "../overlays/OverlayFrame.js";
import { useOverlayState as i } from "../overlays/useOverlayState.js";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
import s from "clsx";
import { useRef as c } from "react";
import { Dialog as l } from "@base-ui/react/dialog";
//#region src/components/dialog/Dialog.tsx
var u = {
	sm: "pf:w-[400px]",
	md: "pf:w-[480px]",
	lg: "pf:w-[600px]",
	xl: "pf:w-[800px]"
};
function d(d) {
	let { trigger: f, title: p, description: m, size: h = "lg", children: g, footerConfig: _, dismissConfig: v, focusConfig: y, className: b } = d, x = i(d, v), S = c(null);
	return /* @__PURE__ */ o(l.Root, {
		open: x.open,
		onOpenChange: x.handleOpenChange,
		disablePointerDismissal: v?.outsidePress === !1,
		children: [f && /* @__PURE__ */ a(l.Trigger, { render: f }), /* @__PURE__ */ o(l.Portal, { children: [/* @__PURE__ */ a(l.Backdrop, { className: s(e, !x.animate && "pf:transition-none") }), /* @__PURE__ */ a(l.Viewport, {
			className: "pf:fixed pf:inset-0 pf:z-50 pf:flex pf:items-center pf:justify-center pf:p-xl",
			children: /* @__PURE__ */ a(l.Popup, {
				ref: S,
				initialFocus: y?.initialFocusRef ?? (() => S.current?.querySelector("[data-overlay-body] input:not(:disabled), [data-overlay-body] textarea:not(:disabled), [data-overlay-body] button:not(:disabled), [data-overlay-body] a[href]") ?? S.current),
				finalFocus: y?.returnFocusRef,
				"aria-busy": x.pending || void 0,
				className: s(t, u[h], "pf:max-w-full pf:max-h-[calc(100dvh-32px)]", x.animate && "pf:transition-[opacity,transform] pf:duration-(--pf-spring-smooth-duration) pf:data-[ending-style]:duration-(--pf-duration-fast) pf:data-[ending-style]:ease-(--pf-easing-out) pf:ease-(--pf-spring-smooth-easing) pf:motion-reduce:transition-opacity pf:motion-reduce:duration-(--pf-duration-fast) pf:motion-reduce:ease-(--pf-easing-out) pf:data-[starting-style]:opacity-0 pf:data-[ending-style]:opacity-0 pf:motion-safe:data-[starting-style]:[transform:translateY(8px)_scale(0.96)] pf:motion-safe:data-[ending-style]:[transform:scale(0.98)]", b),
				children: /* @__PURE__ */ a(r, {
					closeConfig: d.closeConfig,
					heading: /* @__PURE__ */ a(l.Title, {
						className: n,
						children: p
					}),
					description: m && /* @__PURE__ */ a(l.Description, {
						render: /* @__PURE__ */ a("div", {}),
						className: "pf:m-0 pf:mt-xs pf:text-copy-13 pf:text-soft-pearl-900 pf:wrap-anywhere",
						children: m
					}),
					footerConfig: _,
					pending: x.pending,
					error: x.error,
					onClose: (e) => {
						x.requestClose("close", e);
					},
					onCancel: (e) => {
						x.requestClose("cancel", e);
					},
					children: g
				})
			})
		})] })]
	});
}
//#endregion
export { d as Dialog };
